module.exports = __webpack_public_path__ + "img/photo-0053.80c75cc1.jpg";